import { IonCardContent, IonText, useIonToast } from '@ionic/react';
import { phonePortraitOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import ActionButton from '../../../../components/button/ActionButton';
import InputItem from '../../../../components/input/InputItem';
import { DataProvider } from '../../../../library/DataProvider';
import { PasswordRecoveryPostAction } from '../../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

const PasswordRecoveryForm: React.FC = () => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()
    const formPasswordRecovery = useAppSelector(state => state.passwordRecovery)
    const { form_loading, resp } = formPasswordRecovery

    const [form, setForm] = useState({
        mobile: { value: "", validation: { required: true }, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            dispatch(PasswordRecoveryPostAction(form.mobile.value))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    toast({ message: resp.message, duration: 2000, color: "primary" })

                    formProvider.reset();
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    return <IonCardContent>
        <form onSubmit={formSubmitHandler}>
            <IonText className="top-text">جهت بازیابی رمز عبور شماره تلفن همراه خود را وارد کنید.</IonText>

            <InputItem name="mobile" type="tel" label="تلفن همراه" icon={phonePortraitOutline} maxlength={11} ltr spaced provider={formProvider} />

            <ActionButton text="بازیابی رمز عبور" loading={form_loading} />
        </form>
    </IonCardContent>;
}
export default PasswordRecoveryForm